(function ($) {
    // jQuery(document).ready(function () {
    $("html, body").animate({ scrollTop: 0 }, 0);
    $("#customer_login").validate();

    function updateElementHeaderHeight() {
        var headerCartSummary = $('.main-header section.cart .summary').outerHeight();
        $('body').css('--headerCartSummary', headerCartSummary + 'px');
        var marqueeHeight = $('.announcement-bar').outerHeight();
        $('body').css('--marqueeHeightDefault', marqueeHeight + 'px');
        $('body').css('--marqueeHeight', marqueeHeight + 'px');
        const doc = document.documentElement
        doc.style.setProperty('--app-height', `${window.innerHeight}px`)
    }
    updateElementHeaderHeight();

    // Header announcement close
    $('body').on('click', '.marquee-close', function () {
        $('.announcement-bar').addClass('hidden');
        $('body').css('--marqueeHeight', '0px')
        Cookies.set("announcement_bar", true, { expires: 1 });
        updateElementHeaderHeight();
    });
    if (Cookies.get("announcement_bar") == 'true') {
        $('.announcement-bar').addClass('hidden');
    } else {
        $('.announcement-bar').removeClass('hidden');
        updateElementHeaderHeight();
    }

    $(".main-header details summary, .main-header details details-menu").hover(
        function () {
            $('.accounts li').removeClass('active');
            $('body').removeClass('open-cart open-search');
            $('.main-header').addClass('main-header-active');
        }, function () {
            $('.main-header').removeClass('main-header-active');
        }
    );

    // Reposition mega-menu dropdown so it stays within the viewport
    function repositionDropdown() {
        var $details = $('.main-header details.dm.lv1[open]');
        $details.each(function () {
            var $menu = $(this).children('details-menu');
            if (!$menu.length) return;
            $menu.css({ left: '', right: '' });
            var rect = $menu[0].getBoundingClientRect();
            if (rect.right > window.innerWidth - 8) {
                $menu.css({ left: 'auto', right: 0 });
            }
        });
    }
    $('.main-header details.dm.lv1').on('mouseenter mouseover toggle open', function () {
        setTimeout(repositionDropdown, 0);
    });
    $(window).on('resize scroll', repositionDropdown);

    // Header Mobile
    $('.main-header section.dm label').click(function (event) {
        $(this).parents('.menulink').toggleClass('active');
        $(this).parents('section.dm').attr('open', '');
    });
    $('.main-header section.dm-megamenu-link .container > .dropdown-back').click(function (event) {
        $(this).parents('.menulink').removeClass('active');
        $(this).parents('section.dm').removeAttr('open');
        $(this).parents('section.dm').find('summary.dropdown-caret').attr('aria-expanded', 'false');
    });
    $('.main-header section.dm-megamenu-content .dropdown-back').click(function (event) {
        $(this).parents('.menulink').removeClass('active');
        $(this).parents('section.dm').removeAttr('open');
        $(this).parents('section.dm').find('summary.dropdown-caret').attr('aria-expanded', 'false');
    });
    $('.main-header section.dm .dropdown-heading').click(function (event) {
        $(this).parents('.item-inner').toggleClass('active');
    });
    $('.main-header section.dm .dropdown-content .dropdown-back').click(function (event) {
        $(this).parents('.item-inner').toggleClass('active');
    });
    $('.main-header .accounts .hamburger button.is-blank').click(function (event) {
        $('.main-header section.dm').removeAttr('open');
        $('.main-header section.dm .item-inner').removeClass('active');
        $('.main-header section.dm .menulink').removeClass('active');
        $('section.dm').find('summary.dropdown-caret').attr('aria-expanded', 'false');
    });

    // Header cart dropdown
    $('button.carto').click(function (event) {
        event.stopPropagation();
        $('header .menulink details').removeAttr('open');
        $(this).parent('li').siblings('li').removeClass('active');
        $(this).parent('li').toggleClass('active');
        if ($(this).parent('li').hasClass('active')) {
            $('.main-header').addClass('main-header-active');
        } else {
            $('.main-header').removeClass('main-header-active');
        }
    });

    // Header login dropdown
    $('button.loginc').click(function (event) {
        event.stopPropagation();
        $('header .menulink details').removeAttr('open');
        $('body').removeClass('open-cart');
        $(this).parent('li').siblings('li').removeClass('active');
        $(this).parent('li').toggleClass('active');
        if ($(this).parent('li').hasClass('active')) {
            $('.main-header').addClass('main-header-active');
        } else {
            $('.main-header').removeClass('main-header-active');
        }
    });

    // Click outside to close
    $(document).click(function (event) {
        if (!$(event.target).closest(".main-header section.cart, button.carto, .main-header .header-login, button.loginc, .main-header .header-wishlist, a.swym-wishlist, predictive-search, a.fire-search").length) {
            if ($('.main-header').hasClass('main-header-active')) {
                $('.accounts li').removeClass('active');
                $('body').removeClass('open-cart open-search');
                $('.main-header').removeClass('main-header-active');
            }
        }
    });

    $('button.carto, button.loginc, a.swym-wishlist').on('click', function () {
        $('body').removeClass('open-search');
    });

    // Header Search
    $('.main-header .accounts a.fire-search').click(function () {
        $('header .menulink details').removeAttr('open');
        $(this).parent('li').toggleClass('active').siblings('li').removeClass('active');
        if ($(this).parent('li').hasClass('active')) {
            $('.main-header').addClass('main-header-active');
        } else {
            $('.main-header').removeClass('main-header-active');
        }
        if ($('body').hasClass('open-menu')) {
            $('body').removeClass('open-menu');
        }
    })
    $('search-engine button.shrink-search').click(function () {
        $('a.fire-search').parent('li').removeClass('active')
    })

    // Header wishlist
    $('.main-header .accounts .swym-wishlist').click(function (event) {
        event.stopPropagation();
        $('header .menulink details').removeAttr('open');
        $('body').removeClass('open-cart');
        $(this).parent('li').siblings('li').removeClass('active');
        $(this).parent('li').toggleClass('active');
        if ($(this).parent('li').hasClass('active')) {
            $('.main-header').addClass('main-header-active');
        } else {
            $('.main-header').removeClass('main-header-active');
        }
    });

    // If check hasbanner
    if ($('.cms-hasbanner-page').length > 0) {
        $('.main-header').addClass('header-color-white');
    } else {
        $('.main-header').removeClass('header-color-white');
    }

    // Cart Counter
    $(document).on('click', '.main-header section.cart .productsInCart button.is-blank[rv-data-cart-remove]', function () {
        //var itemRemoved = $(this).closest('.productsInCart');
        $(document).ajaxSuccess(function (event, jqxhr, settings) {
            $(document).on('cart.requestComplete', function (event, cart) {
                location.reload();
                $('#counter').attr('data-count', cart.item_count)
                if (cart.item_count == 0) {
                    $('.cartCounter').addClass('cartCounterEmpty');
                }
            });
        });
    });
    $(document).on('click', '.product-form .cartButton', function () {
        $(document).ajaxSuccess(function (event, jqxhr, settings) {
            $(document).on('cart.requestComplete', function (event, cart) {
                $('.cartCounter').removeClass('cartCounterEmpty');
            });
        });
    });

    $(window).scroll(function () {
        updateElementHeaderHeight();
        var scroll = $(window).scrollTop();
        var marqueeHeight = $('.announcement-bar ').outerHeight();

        if (scroll <= marqueeHeight) {
            $('.main-header').removeClass('header-scrolled');
            $("#backtoTop").removeClass('active')
            $('body').css('--marqueeHeight', (marqueeHeight - scroll) + 'px')
        } else {
            $('body').css('--marqueeHeight', '0px')
            $('.main-header').addClass('header-scrolled');
            $("#backtoTop").addClass('active')
        }
    });
    $(window).on('resize load', function () {
        updateElementHeaderHeight();
    });

    // Back to top
    $("#backtoTop").click(function () {
        $("html, body").animate({ scrollTop: 0 }, 750);
    });
    // });
    jQuery(document).ready(function () {
        updateElementHeaderHeight();
    });

})(jQuery);
